/* istanbul ignore file */

export enum MapLayerEnum {
    RoadMap = 'roadmap',
    Satellite = 'hybrid',
    Terrain = 'terrain',
}
